// Recovered compiled webpack factory 29089. Edit this function expression; run npm run build.
(t, e, i) => {
  i.d(e, { x: () => s });
  var n = i(73142);
  function s(t) {
    return (0, n.G)(t) && "ownerSVGElement" in t;
  }
}
